import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import { APP_URL } from '../config';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;

  const logo = (
    <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1024.000000 1024.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,1024.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M4365 8461 c-124 -8 -132 -9 -275 -42 -130 -30 -234 -66 -359 -125
-62 -30 -115 -54 -117 -54 -7 0 -135 -78 -194 -119 -310 -213 -534 -488 -668
-821 -52 -131 -60 -155 -86 -261 -136 -558 -11 -1130 339 -1554 83 -101 225
-245 242 -245 12 0 1133 1123 1133 1136 0 6 -15 17 -32 26 -62 30 -123 94
-153 160 -24 52 -29 77 -29 144 0 69 4 89 29 138 33 66 88 119 154 150 43 20
64 21 366 24 l320 3 662 662 c365 364 659 664 655 668 -12 10 -122 46 -197 64
-193 47 -184 47 -945 50 -399 2 -779 0 -845 -4z"
          />
          <path
            d="M5975 7630 l-610 -610 183 0 c203 0 226 -5 278 -61 32 -35 105 -140
136 -194 31 -57 77 -184 104 -287 36 -141 50 -168 103 -197 l44 -24 566 17
c311 10 621 21 687 25 139 9 160 19 195 89 19 39 21 53 15 135 -35 460 -195
900 -439 1201 -78 98 -275 283 -373 353 -118 85 -246 163 -265 163 -8 0 -289
-274 -624 -610z"
          />
          <path
            d="M4028 5684 c-321 -321 -584 -587 -585 -592 -7 -23 274 -182 462 -262
152 -65 345 -132 575 -201 36 -11 250 -67 475 -124 595 -150 765 -199 924
-265 83 -34 208 -115 269 -174 143 -138 169 -363 64 -570 -58 -117 -195 -253
-275 -275 -30 -9 -244 -11 -757 -9 l-715 3 -48 24 c-111 55 -266 237 -337 396
-43 97 -95 258 -120 373 -11 54 -25 111 -31 129 -13 41 -69 90 -111 98 -28 5
-310 -18 -658 -55 -52 -5 -147 -15 -210 -20 -507 -45 -512 -46 -550 -126 -26
-52 -23 -117 16 -334 53 -295 123 -509 250 -762 85 -169 192 -333 307 -467 62
-72 234 -235 312 -295 226 -175 508 -310 800 -383 65 -17 149 -18 1095 -18
1094 0 1045 -2 1225 50 254 74 498 201 712 371 95 76 294 283 360 374 235 328
346 644 375 1063 40 587 -132 1131 -477 1505 -134 146 -244 236 -417 340 -362
219 -691 338 -1470 531 -437 109 -635 166 -803 230 l-74 29 -583 -584z"
          />
        </g>
      </svg>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  // Render as external link
  return (
    <a
      href={APP_URL}
      target="_blank"
      rel="noopener noreferrer"
      style={{ display: 'block', width: '100%', height: '100%' }}
    >
      {logo}
    </a>
  );
}
